import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

/**
 * 상세 페이지 "Related" 수동 관련글 캐러셀을 Swiper(Navigation)로 감싼다.
 * 버튼은 PHP 마크업에서 data-swiper-prev / data-swiper-next 로 미리 렌더되어 있음.
 * home-news-carousel 패턴과 동일한 방식으로 참조.
 *
 * 캐러셀이 없는 페이지(토글 OFF / 관련글 없음)에서는 조용히 종료.
 */
export class RelatedPostsSwiper {
  static init(): void {
    const carousels = document.querySelectorAll<HTMLElement>(
      ".ui-related-carousel",
    );

    carousels.forEach((carouselEl) => {
      const list = carouselEl.querySelector<HTMLElement>(
        ".ui-related-carousel__list",
      );
      if (!list) return;

      const items = [
        ...list.querySelectorAll<HTMLElement>(".ui-related-carousel__item"),
      ];
      if (!items.length) return;

      // 이미 초기화된 캐러셀은 재초기화에서 건너뛴다(중복 래핑 방지).
      if (carouselEl.dataset.relatedSwiperBound === "true") return;
      carouselEl.dataset.relatedSwiperBound = "true";

      // 슬라이드 클래스 부여
      items.forEach((item) => item.classList.add("swiper-slide"));
      list.classList.add("swiper-wrapper");
      carouselEl.classList.add("swiper");

      // 마크업에 미리 렌더된 버튼/페이지네이션 참조 (data-attr 방식)
      const section      = carouselEl.closest<HTMLElement>(".sec-related-posts-carousel, .sec-related-prev-next");
      const prev         = section?.querySelector<HTMLElement>("[data-swiper-prev]") ?? undefined;
      const next         = section?.querySelector<HTMLElement>("[data-swiper-next]") ?? undefined;
      const paginationEl = section?.querySelector<HTMLElement>("[data-swiper-pagination]") ?? undefined;

      new Swiper(carouselEl, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        // 탭/아코디언 등 초기 숨김 컨테이너 안에서 마운트돼도 노출 시 self-heal.
        observer: true,
        observeParents: true,
        resizeObserver: true,
        navigation: { prevEl: prev, nextEl: next },
        pagination: { el: paginationEl, clickable: true },
      });
    });
  }
}
